import {useHydrationDone} from '@aboutyou/lazy-imports';
import {useEffect} from 'react';
import {useGetSearchSuggestionsTrending} from '../SearchSuggestionsTrending/useGetSearchSuggestionsTrending';
import {preloadSearchPanelChunks} from './ConditionalSearchSuggestionsHistory';

/**
 * Builds the empty search panel out of the way, so opening the bar lands on
 * finished content instead of a skeleton.
 *
 * Nothing happens until the user aims at the bar or focuses it:
 * A pointer reaching the bar precedes the click by long enough to cover the
 * chunks and most of the round trip, and the two go out together rather than
 * the request queueing behind the chunk it needs.
 *
 * To build it for everyone instead, pass `shouldPreload: true` at the call site
 * - both halves are already wired, only held.
 */
export const useSearchPanelPreload = ({
  shouldPreload,
}: {
  shouldPreload: boolean;
}) => {
  // The target group is part of the request's cache key, and pages write their
  // own one to the gender cookie the moment hydration finishes. Asking earlier
  // keys the request on a gender that is about to change, which costs a second
  // request and shows the wrong one's content first. Waiting is free: the flag
  // latches, so the request leaves as soon as hydration lands.
  const isHydrationDone = useHydrationDone();
  const canPreload = shouldPreload && isHydrationDone;

  useEffect(() => {
    if (canPreload) {
      preloadSearchPanelChunks();
    }
  }, [canPreload]);

  useGetSearchSuggestionsTrending({disabled: !canPreload});
};
